export const demoSats = [

    // * Uncommons
    1652587500000000,
    1973822500000000,
    // E0
    648850000000000,
    // 0s
    580000000000000,
    // 2009
    // jan09
    12235000000000,
    // paliblock
    94405000000000,
    // palindromic
    660660000000000,

    // * Black Uncommons
    // E0
    448344999999999,
    790659999999999,
    // 9s vintage
    4099999999999,
    // paliblock 2009
    138364999999999,
    // palindromic
    566599999999999,

    // * 3D Palindromes
    // Nova
    1128211221128211,
    1800880110880081,
    1211522112251121,
    1166911661196611,
    1371311331131731,
    1181831881381811,
    1187187117817811,

    // * 2D Palindromes
    // Paliblock, 3/5 uniform
    303030333030303,
    // Nova
    1115155555515111,

    // * Perfect Palinceptions
    // 2009
    61616166161616,
    78323877832387,
    // Nova
    1950059119500591,
    // 3D
    1198891111988911,
    // 2D
    1444444114444441,
    // 4-4-4-4
    1881188118811881,

    // * Uniform Palinceptions
    // Paliblock
    480847949748084,
    170716373617071,
    154519272915451,
    454546222645454,
    // 3D
    747464767464747,
    737131111131737,
    868060060060868,
    404444545444404,
    // 3D Paliblock
    331331838133133,
    334331343133433,
    111114717411111,
    555555696555555,
    300033111330003,
    // 2D
    677767777767776,
    505000555000505,
    // Nova
    1221788778871221,

    // * Rodarmor Names
    1632683258770602,
    1715394060873569,
    // Pizza
    267296741434331,
    // Paliblock
    255576585647939,
    // Prime
    37974357555131,

    // * Pizza
    282066353660282,
    206160797061602,
    // 4/20
    260579232975062,
    260579222975062,
    // Paliblock
    265679141976562,
    // Uniform Paliblock
    271726656627172,
    // 2009 3D
    184111111111481,
    // 2009
    156239484932651,
    156239414932651,
    // Alpha
    280911500000000,
    260579400000000,
    // Uncommon

    // * Jpeg
    // Palindrome
    152209080902251,
    152209707902251,
    // Alpha
    164764700000000,
    // 2010
    // Uncommon
    152060000000000,

    // * Hitman
    // Palindrome
    937954131459739,
    495712191217594,
    // Alpha
    675358000000000,
    664453700000000,
    // Vintage Alpha
    4122600000000,
    // 2013

    // * Nakamoto
    // Palindrome
    47216588561274,
    79085433458097,
    // Alpha
    47216600000000,

    // * B9
    // Palindrome
    45510601554,
    // 450x Palindrome
    45080708054,

    // * B78
    // Palindrome
    391636636193,
    // 3D
    393923329393,
    // 2D
    393999999393,
    // Alpha
    393800000000,
    // Uniform
    393171171393,

    // * Alpha
    // * Omega
    106601999999999,

    // * Vintage
    // Paliblock
    4895368635984,
    2876312136782,
    // Paliblock 3D
    4144004004414,
    // 3D
    3933919193393,
    3633886883363,
];